import { useCallback } from 'react';

interface UseKeyValueEditorProps {
  value: Record<string, string>;
  onChange: (value: Record<string, string>) => void;
}

export function useKeyValueEditor({ value, onChange }: UseKeyValueEditorProps) {
  const safeValue = value || {};
  const entries = Object.entries(safeValue);

  const addItem = useCallback(() => {
    onChange({ ...safeValue, ['']: '' });
  }, [safeValue, onChange]);

  const removeItem = useCallback(
    (key: string) => {
      const newValue = Object.fromEntries(Object.entries(safeValue).filter(([k]) => k !== key));
      onChange(newValue);
    },
    [safeValue, onChange]
  );

  const updateKey = useCallback(
    (oldKey: string, newKey: string) => {
      if (oldKey === newKey) return;
      const itemValue = safeValue[oldKey];
      const newValue = Object.fromEntries(
        Object.entries(safeValue)
          .filter(([k]) => k !== oldKey)
          .concat([[newKey, itemValue]])
      );
      onChange(newValue);
    },
    [safeValue, onChange]
  );

  const updateValue = useCallback(
    (key: string, newValue: string) => {
      onChange({
        ...safeValue,
        [key]: newValue
      });
    },
    [safeValue, onChange]
  );

  return {
    entries,
    addItem,
    removeItem,
    updateKey,
    updateValue
  };
}
